// Tab list, URL-hash rules and header-tag copy for the tabbed Concierge page
// (spec docs/superpowers/specs/2026-10-07-concierge-tabs-design.md).

export const TABS = [
  { id: 'overview', label: 'Overview' },
  { id: 'todo', label: 'To-do' },
  { id: 'texts', label: 'Texts' },
  { id: 'notes', label: 'Notes' },
  { id: 'schools', label: 'Schools' },
  { id: 'wellness', label: 'Wellness' },
  { id: 'documents', label: 'Documents' },
  { id: 'video', label: 'Video' },
  { id: 'details', label: 'Details' },
];

// The open-items queue has always linked to .../concierge#todos.
const LEGACY = { todos: 'todo' };

export function tabFromHash(hash) {
  const raw = (hash || '').replace(/^#/, '');
  const id = LEGACY[raw] || raw;
  return TABS.some(t => t.id === id) ? id : 'overview';
}

// Codes stay in sync with CONCIERGE_CLASSIFICATION_VALUES in backend/app/routers/concierge.py.
const CLASSIFICATIONS_FULL = [
  { code: 'ncaa_d1_fbs', label: 'NCAA Division I — FBS', short: 'NCAA D-I FBS' },
  { code: 'ncaa_d1_fcs', label: 'NCAA Division I — FCS', short: 'NCAA D-I FCS' },
  { code: 'ncaa_d1_nonfb', label: 'NCAA Division I — Non-Football', short: 'NCAA D-I' },
  { code: 'ncaa_d2', label: 'NCAA Division II', short: 'NCAA D-II' },
  { code: 'ncaa_d3', label: 'NCAA Division III', short: 'NCAA D-III' },
  { code: 'naia', label: 'NAIA', short: 'NAIA' },
  { code: 'njcaa_d1', label: 'NJCAA Division I', short: 'NJCAA D-I' },
  { code: 'njcaa_d2', label: 'NJCAA Division II', short: 'NJCAA D-II' },
  { code: 'njcaa_d3', label: 'NJCAA Division III', short: 'NJCAA D-III' },
];

export const CONCIERGE_CLASSIFICATIONS = CLASSIFICATIONS_FULL.map(({ code, label }) => ({ code, label }));

export function classificationShort(code) {
  return CLASSIFICATIONS_FULL.find(c => c.code === code)?.short || null;
}

const MON = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

export function daysUntil(iso, todayIso) {
  const a = Date.parse(`${iso.slice(0, 10)}T00:00:00Z`);
  const b = Date.parse(`${todayIso}T00:00:00Z`);
  return Math.round((a - b) / 86400000);
}

export function conciergeTagText({ isConcierge, endsIso, todayIso }) {
  if (!isConcierge) return null;
  if (!endsIso) return 'CONCIERGE';
  const [, m, d] = endsIso.slice(0, 10).split('-').map(Number);
  const date = `${MON[m - 1]} ${d}`;
  const n = daysUntil(endsIso, todayIso);
  if (n < 0) return `CONCIERGE · ENDED ${date}`;
  if (n === 0) return `CONCIERGE · ENDS ${date} · TODAY`;
  return `CONCIERGE · ENDS ${date} · ${n} DAY${n === 1 ? '' : 'S'} LEFT`;
}
